import React from 'react';
import "./Tooltip.scss";
import classNames from 'classnames'

const Tooltip = ({children, tip, direction}) => {

  return (<div className="dw-tooltip">
    {children}
    <div className={classNames("tooltip-container", direction)}>
      {tip}
    </div>
  </div>)
}

export default Tooltip;
